import React, { Fragment, useContext } from 'react'
import { Form, Cardm, FormLabel, InputGroup } from 'react-bootstrap'
import { FormErrorContext } from './FormErrorContext';
import _ from 'lodash'
import { MessagesContext } from '../messages/MessagesContext';

export const FormField = (props) => {
    const { formErrors } = useContext(FormErrorContext);
    const { messages } = useContext(MessagesContext);

    let fieldError = undefined;
    let valstate = props.valstate;
    if (!_.isEmpty(formErrors)) {
        fieldError = formErrors[props.name];
        valstate = false;
    }

    return (
        <Form.Group controlId={props.name}>
            {/* CheckBox */}
            {props.type === 'checkbox' &&
                <Fragment>
                    <Form.Check
                        label={props.label}
                        type={props.checktype}
                        checked={props.checked}
                        onChange={props.onChange}
                        name={props.name}
                        disabled={props.disabled}
                        style={{ backgroundColor: props.valstate ? "" : "pink", ...props.style }}
                        value={props.value}
                        className={props.className}
                    />
                </Fragment>
            }

            {/* TextArea */}
            {props.type === 'textarea' &&
                <Fragment>
                    <Form.Label>{props.label}</Form.Label>
                    <Form.Control
                        as="textarea"
                        name={props.name}
                        rows={props.rows || 3}
                        value={props.value}
                        disabled={props.disabled}
                        ref={props.rref}
                        style={{ backgroundColor: props.valstate ? "" : "pink", ...props.style }}
                        onChange={props.onChange}
                        onBlur={props.onBlur}
                        isInvalid={!valstate}
                        readOnly={props.readOnly}
                        className={props.className}
                    />
                </Fragment>
            }

            {/* Text */}
            {(props.type === 'text' || props.type === 'date' || props.type === 'datetime' || props.type === 'password') &&
                <React.Fragment>
                    <Form.Label>{props.label}</Form.Label>
                    {/*The input groups causes the disappearance of right and left borders.
                    seems like a spacing issue. Since inner button is only uses with login scree
                    I have made the input groups conditional until it is determined what the style
                    should be*/}
                    {props.innerButton &&
                        <InputGroup>
                            <Form.Control
                                name={props.name}
                                type={props.type}
                                placeholder={props.placeholder}
                                value={props.value || ""}
                                style={{ backgroundColor: props.valstate ? "" : "pink" }}
                                onChange={props.onChange}
                                onBlur={props.onBlur}
                                onKeyDown={props.onKeyDown}
                                isInvalid={!valstate}
                                readOnly={props.readOnly}
                                ref={props.rref}
                                className={props.className}
                            />
                            {props.innerButton && <props.innerButton />}
                            {/*!props.valstate && (<Form.Control.Feedback type="invalid">{props.valMsg}</Form.Control.Feedback>)*/}
                            {/*fieldError && (<Form.Control.Feedback type="invalid">{fieldError}:{messages[fieldError]}</Form.Control.Feedback>)*/}

                        </InputGroup>
                    }
                    {!props.innerButton &&
                        <Form.Control
                            name={props.name}
                            type={props.type}
                            placeholder={props.placeholder}
                            value={props.value || ""}
                            style={{ backgroundColor: props.valstate ? "" : "pink" }}
                            onChange={props.onChange}
                            onBlur={props.onBlur}
                            onKeyDown={props.onKeyDown}
                            isInvalid={!valstate}
                            readOnly={props.readOnly}
                            ref={props.rref} 
                            className={props.className}/>
                    }
                    {props.supplementaryText && <FormLabel>&nbsp;{props.supplementaryText}</FormLabel>}
                </React.Fragment>

            }

            {(props.type === 'select') &&
                <Fragment>
                    <Form.Label>{props.label}</Form.Label>
                    <Form.Select
                        name={props.name}
                        style={{ backgroundColor: props.valstate ? "" : "pink" }}
                        onChange={props.onChange}
                        onBlur={props.onBlur}
                        isInvalid={!valstate}
                        disabled={props.disabled || props.readOnly}
                        value={props.value}
                        defaultValue={props.defaultValue}
                        className={props.className}>
                        {props.children}
                    </Form.Select>
                </Fragment>
            }


            {!props.valstate && (<Form.Control.Feedback type="invalid">{props.valMsg}</Form.Control.Feedback>)}
            {fieldError && (<Form.Control.Feedback type="invalid">{fieldError}:{messages[fieldError]}</Form.Control.Feedback>)}

        </Form.Group>
    );
}
